import { Config } from "./config";

export const productionConfig: Config = {
	Sentry: {
		dsn: 'https://44d193a246344b6cb4fbe9457ed1c200@o4505521980375040.ingest.sentry.io/4505521986600960'
	}
}
